<template>
  <label class="font-label text-fg-secondary uppercase text-xs guest-ui:text-fg-disclaimer">
    <slot></slot>
  </label>
</template>
